import { render, staticRenderFns } from "./defra-fuels.vue?vue&type=template&id=1a0c822c&scoped=true"
import script from "./defra-fuels.vue?vue&type=script&lang=js"
export * from "./defra-fuels.vue?vue&type=script&lang=js"
import style0 from "./defra-fuels.vue?vue&type=style&index=0&id=1a0c822c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0c822c",
  null
  
)

export default component.exports